export default __webpack_public_path__ + "f1bb33fa109e41dc2a6d7fdd41e85b58.png";